import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'

import { useOrgPerm } from '@/hooks/useOrgPerm'
import { ADD_NEW_APP_ROUTE } from '@/shared/constants'
import { WrapperProps } from '@/shared/routes'
import Layout from '@/components/Layout'
import { PageUnauthorized } from '@/components/PageUnauthorized'

const OrgDetailAddNewAppsPage = lazy(() => import('./OrgAddNewAppPage'))
const OrgDetailAppsPage = lazy(() => import('./OrgAppsPage'))

// apps routes config
export const appsRoutes = [
  {
    index: true,
    name: 'Apps',
    component: OrgDetailAppsPage,
  },
  {
    path: ADD_NEW_APP_ROUTE,
    name: 'Add New App',
    component: OrgDetailAddNewAppsPage,
  },
]

export default function OrgDetailAppRoutes({ title }: WrapperProps) {
  const canViewListApp = useOrgPerm(OrgPermission.AppsViewListOfApps)

  if (!canViewListApp) {
    return (
      <Layout title={title}>
        <PageUnauthorized />
      </Layout>
    )
  }

  return (
    <Routes>
      {appsRoutes.map(({ component: Comp, ...rest }) => {
        return (
          <Route
            index={rest.index}
            path={rest.index ? undefined : rest.path}
            key={rest.name}
            element={<Comp title={title} />}
          />
        )
      })}
    </Routes>
  )
}
